export const ACTION = {
  APPLY_TEXTURE: 'APPLY_TEXTURE',
  APPLY_MATERIAL: 'APPLY_MATERIAL',
  SELECT_OBJECT: 'SELECT_OBJECT',
}